import { useApi } from '@/composables/useApi'

const api = useApi()

export default function PlanoService() {
  this.createUpgradePlano = function (id_user, plano) {
    return new Promise((resolve, reject) => {
      try {
        api.post(`/upgradePlano/${id_user}`, {
          plano,
        }).then(resp => {
          resolve(resp.data[0])
        })
      } catch (error) {
        reject(error)
      }
    })
  }
}
